module.exports = "/static/js/643bf8f203123680a9dc167abf53c5ad.png";